import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from '../components/Layout';
import ProtectedRoute from '../components/ProtectedRoute';
import AdminGuard from '../components/AdminGuard';
import AuthRoutes from './AuthRoutes';
import {
  DriverDashboard,
  Dashboard,
  Products,
  ProductInventory,
  CreateProduct,
  EditProduct,
  AdjustInventory,
  AdjustReview,
  DarkstoreBrand,
  DarkstoreListings,
  Orders,
  OrderDetail,
  Payouts,
  Transfers,
  Transactions,
  History,
  Settings,
} from './lazyPages';

export default function PortalRoutes({ isAuthenticated }: { isAuthenticated: boolean }) {
  return (
    <Routes>
      {AuthRoutes({ isAuthenticated })}

      {/* Driver dashboard - admin only */}
      <Route path="/driver" element={<ProtectedRoute><AdminGuard><DriverDashboard /></AdminGuard></ProtectedRoute>} />

      {/* Protected Routes */}
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        {/* Default route goes to dashboard */}
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />

        {/* Product management routes - static paths MUST come before dynamic :sku */}
        <Route path="products" element={<Products />} />
        <Route path="products/inventory" element={<ProductInventory />} />
        <Route path="products/create" element={<CreateProduct />} />
        <Route path="products/:sku/edit" element={<EditProduct />} />
        <Route path="products/:sku" element={<Products />} />

        {/* Inventory and operations */}
        <Route path="inventory" element={<Navigate to="/products/inventory" replace />} />
        <Route path="inventory/adjust" element={<AdjustInventory />} />
        <Route path="inventory/adjust/review" element={<AdjustReview />} />

        {/* Darkstore */}
        <Route path="darkstore" element={<DarkstoreBrand />} />
        <Route path="darkstore/brand" element={<DarkstoreBrand />} />
        <Route path="darkstore/listings" element={<DarkstoreListings />} />
        <Route path="darkstore/orders" element={<Orders />} />
        <Route path="darkstore/orders/:orderNumber" element={<OrderDetail />} />
        <Route path="darkstore/payouts" element={<Payouts />} />

        {/* Orders & Payouts (legacy routes) */}
        <Route path="orders" element={<Orders />} />
        <Route path="orders/:orderNumber" element={<OrderDetail />} />
        <Route path="payouts" element={<Payouts />} />

        <Route path="transfers" element={<Transfers />} />
        <Route path="transactions" element={<Transactions />} />
        <Route path="history" element={<History />} />

        {/* Settings */}
        <Route path="settings" element={<Settings />} />
      </Route>

      {/* Catch all route */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
